module.exports = __webpack_public_path__ + "img/070.5fa8b2e7.png";